import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../utils/axios';
import { Button } from '../ui/button';
import { MigracionResultadoGenerico } from './MigracionResultadoGenerico';

// Parte 0.1: diagnóstico (solo lectura) de CVU de bancos sponsor anteriores reactivados.
export const DiagnosticoCvusAnteriores = () => {
  const [r, setR] = useState(null);
  const [cargando, setCargando] = useState(false);
  const ver = async () => {
    setCargando(true);
    try {
      const { data } = await api.get('/padron-interno/diagnostico/cvus-bancos-anteriores', { timeout: 300000 });
      setR(data);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'No se pudo calcular el diagnóstico');
    } finally {
      setCargando(false);
    }
  };
  return (
    <div className="space-y-3" data-testid="diagnostico-cvus-paso">
      <Button onClick={ver} disabled={cargando} data-testid="diagnostico-cvus-ver">
        {cargando ? <Loader2 size={16} className="mr-2 animate-spin" /> : null} Ver diagnóstico
      </Button>
      {r && <MigracionResultadoGenerico r={r} />}
    </div>
  );
};
